/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Component } from "@angular/core";

@Component({
	selector: "globalictcc-privacy-statement",
	standalone: true,
	templateUrl: "./privacy-statement.component.html",
	styleUrl: "./privacy-statement.component.scss"
})
export class PrivacyStatementComponent {}
